import React from 'react';
import { Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

export const MultiLineTruncatedCell = ({ maxLength,
  text,
  noOfLines = 2,
  textStyle = 'bodyMd600',
  textAlign = 'left' }) => (
    <Tooltip isDisabled={text.length < maxLength} label={text}>
      <Text noOfLines={noOfLines} textAlign={textAlign} textStyle={textStyle}>{text}</Text>
    </Tooltip>
);

MultiLineTruncatedCell.propTypes = {
  text: PropTypes.string,
  maxLength: PropTypes.number,
  noOfLines: PropTypes.number,
  textStyle: PropTypes.string,
  textAlign: PropTypes.string
};
